export class User {
  userName: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
  email: string | undefined;
  emailVerified: boolean | undefined = false;
  roles: string[] = [];

  get fullName(): string | null {
    if (!this.first_name || !this.last_name) return null;
    return `${this.first_name} ${this.last_name}`;
  }

  get firstNameInitial(): string | null {
    if (!this.first_name || !this.last_name) return null;
    return this.first_name[0];
  }

  get lastNameInitial(): string | null {
    if (!this.last_name) return null;
    return this.last_name[0];
  }
}
